import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import Loader from "../Loader";
import React, { useState, useEffect, useRef } from "react";
import sage from "../../../images/splash/sage.jpeg";
import html2canvas from 'html2canvas';
import QRCode from 'react-qr-code';

const AppdownloadQR = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [qrValue, setQrValue] = useState('');
  const [qrValueAndroid, setQrValueAndroid] = useState('');
  const [qrValueIOS, setQrValueIOS] = useState('');
  const qrCodeRef = useRef(null);
  const qrCodeAndroidRef = useRef(null);
  const qrCodeIOSRef = useRef(null);

  useEffect(() => {
    setQrValue('http://sage-sq.suyaptech.com/new-dashboard');
    setQrValueAndroid('https://play.google.com/store/apps/details?id=com.sagesalonsg.com');
    setQrValueIOS('https://apps.apple.com/in/app/sage-sg/id6633419174');
  }, []);

  const downloadQRCode = async (ref, filename, text) => {
    try {
      const node = ref.current;
      if (!node) {
        console.error('QR code container not found.');
        return;
      }

      const textElement = document.createElement('h6');
      textElement.innerText = text;
      textElement.style.textAlign = 'center';
      textElement.style.alignItems = 'center';
      textElement.style.alignItems = 'center';

      node.appendChild(textElement);

      const canvas = await html2canvas(node, {
        backgroundColor: '#ffffff', // Ensure the background is white
      scale: 2, // Increase the scale for higher resolution
      width: node.offsetWidth + 20, // Adding 10px padding on each side (left + right = 20px)
      height: node.offsetHeight + 20, // Adding 10px padding on each side (top + bottom = 20px)
      x: -10, // Shifting x-position by -10px to accommodate left padding
      y: -10, 
      });

      const dataUrl = canvas.toDataURL('image/png');

      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      node.removeChild(textElement);
    } catch (error) {
      console.error('Failed to download QR code:', error);
    }
  };

  

  return (
    <>
      {isLogin && <Loader />}
      <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
        <Navbar.Brand href="#home">
          <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
              APP DOWNLOAD QR
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
              <button className="btn" style={{ backgroundColor:"rgb(89, 128, 71)", color:"white" }}>
                <i className="bi bi-house"></i> Go to home
              </button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <br />
      <br />
      <br />
      <br />
      <div>
      <div>
  <div className="row mt-4 justify-content-center">
    {/* Customer Website QR Code */}
    {/* <div className="col-12 col-md-4 d-flex justify-content-center mb-4">
  <div
    className="card d-flex flex-column align-items-center p-4"
    style={{
      height: '400px',
      width: '300px',
      overflow: 'hidden', 
    }}
  >
    <img
      src={sage}
      alt="Sage Logo"
      className="img-fluid"
      style={{ maxWidth: '100px', marginBottom: '10px' }}
    />
    <h5>Customer Website</h5>
    <div ref={qrCodeRef} className="qrcode-container mt-3">
      {qrValue && <QRCode value={qrValue} size={150} />}
    </div>
    <div className="button-container mt-3">
      {qrValue && (
        <button
          className="btn btn-success"
          onClick={() =>
            downloadQRCode(
              qrCodeRef,
              'customer-website-qr.png',
              'Scan this QR code for customer website for booking.'
            )
          }
        >
          Download QR
        </button>
      )}
    </div>
  </div>
</div> */}


    {/* Android App QR Code */}
    <div className="col-12 col-md-4 d-flex justify-content-center mb-4">
      <div className="card d-flex flex-column align-items-center p-4"
       style={{
        height: '400px', 
        width: '300px', 
        overflow: 'hidden',
      }}>
        <img
          src={sage}
          alt="Sage Logo"
          className="img-fluid"
          style={{ maxWidth: '100px', marginBottom: '10px' }}
        />
        <h5>Customer Android App</h5>
        <div ref={qrCodeAndroidRef} className="qrcode-container mt-3">
          {qrValueAndroid && <QRCode value={qrValueAndroid} size={150} />}
        </div>
        <div className="button-container mt-3">
          {qrValueAndroid && (
            <button
              className="btn btn-success"
              onClick={() =>
                downloadQRCode(
                  qrCodeAndroidRef,
                  'customer-android-qr.png',
                  'Scan this QR code for customer Android App for booking.'
                )
              }
            >
              Download QR
            </button>
          )}
        </div>
      </div>
    </div>

    {/* IOS App QR Code */}
    <div className="col-12 col-md-4 d-flex justify-content-center mb-4">
      <div className="card d-flex flex-column align-items-center p-4"
       style={{
        height: '400px',
        width: '300px', 
        overflow: 'hidden',
      }}>
        <img
          src={sage}
          alt="Sage Logo"
          className="img-fluid"
          style={{ maxWidth: '100px', marginBottom: '10px' }}
        />
        <h5>Customer IOS App</h5>
        <div ref={qrCodeIOSRef} className="qrcode-container mt-3">
          {qrValueIOS && <QRCode value={qrValueIOS} size={150} />}
        </div>
        <div className="button-container mt-3">
          {qrValueIOS && (
            <button
              className="btn btn-success"
              onClick={() =>
                downloadQRCode(
                  qrCodeIOSRef,
                  'customer-ios-qr.png',
                  'Scan this QR code for customer iOS App for booking.'
                )
              }
            >
              Download QR
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
</div>

        {/* </div> */}
      </div>
    </>
  );
};

export default AppdownloadQR;
